// import React from "react";
// // import Checkbox from "../Checkbox";
// // import Accordion from "../Accordion";
// // import OutputFactory from "../OutputFactory";
// import CollapseView from "./CollapseView";
// // import AccordionProvider from "../Accordion/AccordionProvider";
// // import AccordionCollapse from "../Accordion/AccordionCollapse";
// import { Accordion, Checkbox, OutputFactory } from "../../nq-component";
// import AccordionCollapse from "../../nq-component/Accordion/AccordionCollapse";
// import AccordionProvider from "../../nq-component/Accordion/AccordionProvider";

// let timeoutId;

// function Body({
//   objects,
//   fields,
//   excludeFields,
//   selected,
//   selectable,
//   onSelect,
//   onClick,
//   onLongPress,
//   actionsList,
//   collapsable,
//   onCollapse,
//   toggleable,
//   actions,
//   onClickItem,
//   fieldImage,
// }) {
//   const onPointerDown = () => {
//     timeoutId = setTimeout(onLongPress, 500); // set long press time to 500ms
//   };

//   const onPointerUp = () => {
//     clearTimeout(timeoutId);
//   };

//
//   return objects.map((object, index) => {
//     const id = object.id || object._id;
//     const checked = selected.includes(object);
//     return (
//       <AccordionProvider key={id}>
//         <tr>
//           {selectable && (
//             <th className="align-middle">
//               <Checkbox
//                 checked={checked}
//                 id={"check_" + id}
//                 onChange={() => onSelect(index)}
//               />
//             </th>
//           )}

//           {/* <th className="align-middle">{object.roles[0].name}</th> */}

//           {Object.keys(fields).map((field, i) => {
//             const options = fields[field];
//             if (excludeFields.includes(field)) return null;
//             return (
//               <Accordion
//                 as="td"
//                 eventKey={`_${id}`}
//                 key={field}
//                 className="fs-sm text-truncate"
//                 onPointerDown={onPointerDown}
//                 onPointerUp={onPointerUp}
//                 // onClick={() => onClick(index, field)}
//                 style={{
//                   cursor: "pointer",
//                   maxWidth: "15em",
//                 }}
//               >
//                 <OutputFactory field={field} object={object} {...options} />
//               </Accordion>
//             );
//           })}
//           {actionsList.length > 0 && (
//             <td>
//               <div style={{ width: "50px" }}></div>
//             </td>
//           )}
//           {actionsList.map((action) => {
//             return (
//               <td className="text-truncate">
//                 <button
//                   onClick={action.onClick && action.onClick.bind(this, index)}
//                   className="btn btn-outline-primary btn-sm fs-xs shadow-none"
//                 >
//                   <i className={action.icon} /> {action.label}
//                 </button>
//               </td>
//             );
//           })}
//           <td>
//             <div>
//               <i
//                 className={
//                   collapsable ? "bi bi-chevron-down" : "bi bi-chevron-up"
//                 }
//                 style={{ color: "#FFB200" }}
//               ></i>
//             </div>
//           </td>
//         </tr>
//         {collapsable && (
//           <tr>
//             <td className="p-0" colSpan={Object.keys(fields).length + 1}>
//               <AccordionCollapse
//                 toggleable={toggleable}
//                 className="collapse p-3 "
//                 eventKey={`_${id}`}
//               >
//                 {onCollapse(index, object, excludeFields) ||
//                   CollapseView(
//                     index,
//                     object,
//                     excludeFields,
//                     fields,
//                     actions,
//                     onClickItem,
//                     fieldImage
//                   )}
//               </AccordionCollapse>
//             </td>
//           </tr>
//         )}
//       </AccordionProvider>
//     );
//   });
// }

// export default Body;

import React, { useState } from "react";
// import Checkbox from "../Checkbox";
// import Accordion from "../Accordion";
// import OutputFactory from "../OutputFactory";
import CollapseView from "./CollapseView";
// import AccordionProvider from "../Accordion/AccordionProvider";
// import AccordionCollapse from "../Accordion/AccordionCollapse";
import { Checkbox, OutputFactory } from "../../nq-component";
import AccordionCollapse from "../../nq-component/Accordion/AccordionCollapse";
import AccordionProvider from "../../nq-component/Accordion/AccordionProvider";
import { motion } from "framer-motion";
import { container, item } from "../../animationUtils";
import Accordion from "../Accordion";

let timeoutId;

function Body({
  objects,
  fields,
  excludeFields,
  selected,
  selectable,
  onSelect,
  onClick,
  onLongPress,
  actionsList,
  collapsable,
  toggleable,
  actions,
  onClickItem,
  fieldImage,
  onCollapse,
}) {
  // State to track which rows are collapsable (open or closed)
  const [collapsedRows, setCollapsedRows] = useState([]);

  const onPointerDown = () => {
    timeoutId = setTimeout(onLongPress, 500); // set long press time to 500ms
  };

  const onPointerUp = () => {
    clearTimeout(timeoutId);
  };

  const toggleCollapse = (index) => {
    setCollapsedRows((prevState) => {
      const newCollapsedRows = [...prevState];
      if (newCollapsedRows.includes(index)) {
        // If already collapsed, remove it (toggle to not collapsed)
        return newCollapsedRows.filter((i) => i !== index);
      } else {
        // If not collapsed, add it (toggle to collapsed)
        return [...newCollapsedRows, index];
      }
    });
  };

  return objects.map((object, index) => {
    const id = object.id || object._id;
    const checked = selected.includes(object);
    const isCollapsed = collapsedRows.includes(index);

    // onClick(object, index);

    return (
      <AccordionProvider key={id}>
        <motion.tr
          variants={container(0.1)}
          initial="hidden"
          animate="show"
          onClick={() => onClick(object, index)}
        >
          {/* <tr onClick={() => toggleCollapse(index)}> */}
          {selectable && (
            <th className="align-middle">
              <Checkbox
                checked={checked}
                id={"check_" + id}
                onChange={() => onSelect(index)}
              />
            </th>
          )}

          <td
            style={{
              cursor: "pointer",
              maxWidth: "15em",
            }}
            className="fs-sm text-truncate"
          >
            {object?.employee?.lastName}
          </td>

          {Object.keys(fields).map((field, i) => {
            const options = fields[field];
            if (excludeFields.includes(field)) return null;
            return (
              <Accordion
                // as="td"
                as={motion.td}
                eventKey={`_${id}`}
                variants={item}
                key={field}
                className="fs-sm text-truncate"
                onPointerDown={onPointerDown}
                onPointerUp={onPointerUp}
                style={{
                  cursor: "pointer",
                  maxWidth: "15em",
                }}
              >
                <OutputFactory field={field} object={object} {...options} />
              </Accordion>
            );
          })}
          <td
            style={{
              cursor: "pointer",
              maxWidth: "15em",
            }}
            className="fs-sm text-truncate"
          >
            {object?.employee?.status}
          </td>
          {actionsList.length > 0 && (
            <td>
              <div style={{ width: "50px" }}></div>
            </td>
          )}
          {actionsList.map((action) => (
            <td className="text-truncate" key={action.label}>
              <button
                onClick={(e) => {
                  e.stopPropagation(); // Prevent table row click when action button is clicked
                  action.onClick && action.onClick(index);
                }}
                className="btn btn-outline-primary btn-sm fs-xs shadow-none"
              >
                <i className={action.icon} /> {action.label}
              </button>
            </td>
          ))}
          <td>
            <div>
              <i
                className={
                  !isCollapsed ? "bi bi-chevron-down" : "bi bi-chevron-up"
                }
                style={{ color: "#FFB200" }}
              ></i>
            </div>
          </td>
          {/* </tr> */}
        </motion.tr>

        {collapsable && (
          <tr>
            <td className="p-0" colSpan={Object.keys(fields).length + 1}>
              <AccordionCollapse
                toggleable={toggleable}
                className="collapse p-3"
                eventKey={`_${id}`}
              >
                {onCollapse(index, object, excludeFields) ||
                  CollapseView(
                    index,
                    object,
                    excludeFields,
                    fields,
                    actions,
                    onClickItem,
                    fieldImage
                  )}
              </AccordionCollapse>
            </td>
          </tr>
        )}
      </AccordionProvider>
    );
  });
}

export default Body;
